<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">
        {{"case." + (isUpdate ? 'Edit' : 'Add') + " Phase of Treatment Plan" | translate}}
      </h4>

      <button type="button" class="close" aria-label="Close" matDialogClose>
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body p-4">
      <form [formGroup]="formGroup">
        <mat-form-field>
          <mat-label>{{ 'case.Choose Phase' | translate }}</mat-label>
          <mat-select formControlName="medicalPhaseId" [class.loading-field]="dataLoading"
            (selectionChange)="handleFields()">
            <mat-select-trigger *ngIf="selectedViewValue">
              <div class="svg-card">
                <div [innerHTML]="selectedViewValue.icon | sanitizeHtml"></div>
              </div>
              {{ selectedViewValue.name }}
            </mat-select-trigger>
            <mat-option [value]=""></mat-option>
            <mat-option *ngFor="let item of phases" [value]="item.id">
              <!-- <img [src]="item.icon" alt="">  -->
              <div class="svg-card">
                <div [innerHTML]="item.icon | sanitizeHtml"></div>
              </div>
              {{item.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('medicalPhaseId', 'required')">
            {{ 'meetings.Required' | translate }}
          </mat-error>
        </mat-form-field>

        <div class="my-4" formArrayName="medicalPhasefields">
          <ng-container *ngIf="medicalPhasefieldsArray.controls.length">
            <div class="mb-2 fontMedium">{{'case.Treatment Details' | translate}}</div>

            <div *ngFor="let field of medicalPhasefieldsArray.controls; let i = index" [formGroupName]="i">
              <mat-form-field>
                <mat-label>{{ fields[i].fieldname }}</mat-label>

                <ng-container *ngIf="fields[i].fieldType == 'list'">
                  <mat-select matInput formControlName="fieldValue" [class.loading-field]="fields[i].loading">
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngFor="let val of fields[i].list" [value]="val.id">
                      {{val.name}}
                    </mat-option>
                  </mat-select>
                </ng-container>
                <ng-container *ngIf="fields[i].fieldType == 'text'">
                  <input matInput type="text" formControlName="fieldValue">
                </ng-container>

                <mat-error *ngIf="fieldHasError('fieldValue', i, 'required')">
                  {{ 'meetings.Required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

          </ng-container>
        </div>

        <div>
          <div class="mb-2 fontMedium">{{'case.Treatment Schedule' | translate}}</div>

          <mat-form-field>
            <mat-label>{{ 'case.Cycle Number' | translate }}</mat-label>
            <input matInput type="text" formControlName="cycleNumber">
            <mat-error *ngIf="hasError('cycleNumber', 'required')">
              {{ 'meetings.Required' | translate }}
            </mat-error>
          </mat-form-field>

          <div class="row">
            <div class="col-6">
              <mat-form-field>
                <mat-label> {{ 'tasks.StartDate' | translate }}</mat-label>
                <input matInput [min]="today" [matDatepicker]="startPicker" readonly formControlName="startDate">
                <mat-icon matDatepickerToggleIcon *ngIf="formGroup.controls['startDate'].value"
                  (click)="formGroup.controls['startDate'].setValue('')">clear</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>

                <mat-error *ngIf="hasError('startDate', 'required')">
                  {{ 'meetings.Required' | translate }}
                </mat-error>
                <mat-error
                  *ngIf="hasError('startDate', 'matDatepickerMin') || hasError('startDate', 'matDatepickerMax')">
                  {{ 'messages.dateInvalid' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field>
                <mat-label> {{ 'voting.EndDate' | translate }}</mat-label>
                <input matInput [min]="formGroup.controls['startDate'].value" [matDatepicker]="endPicker" readonly
                  formControlName="endDate">
                <mat-icon matDatepickerToggleIcon *ngIf="formGroup.controls['endDate'].value"
                  (click)="formGroup.controls['endDate'].setValue('')">clear</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>

                <mat-error *ngIf="hasError('endDate', 'required')">
                  {{ 'meetings.Required' | translate }}
                </mat-error>
                <mat-error *ngIf="hasError('endDate', 'matDatepickerMin') || hasError('endDate', 'matDatepickerMax')">
                  {{ 'messages.dateInvalid' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <mat-form-field>
              <mat-label>{{ 'case.Additional Notes' | translate }}</mat-label>
              <input matInput type="text" formControlName="additionalNotes">
              <mat-error *ngIf="hasError('additionalNotes', 'required')">
                {{ 'meetings.Required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="modal-btns mt-5">
          <button type="reset" class="close closebtn" matDialogClose>
            {{ 'swalMsg.cancel' | translate }}
          </button>
          <button mat-raised-button class="btn customBtn px-4" (click)="save()" [disabled]="loading"
            [ngClass]="{ 'loading': loading}">
            {{"voting.Submit" | translate}}
          </button>
        </div>
      </form>

    </div>

  </div>
</div>
